import Morpheus from "@tm/morpheus"
import { PostMessageOptions } from "."

export function handleCloseModal({ data }: PostMessageOptions) {
    if (!data.closeModal) {
        return
    }
    Morpheus.closeView("1")
}
